export function CbSvgIcon() {
  return (
    <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="52" height="52" rx="16" fill="#F0FAFF" />
      <path
        d="M18.2433 32.0003V22.5714C18.2433 22.0743 18.6462 21.6714 19.1433 21.6714C19.6403 21.6714 20.0433 22.0743 20.0433 22.5714V32.0003C20.0431 32.4972 19.6402 32.9003 19.1433 32.9003C18.6463 32.9003 18.2434 32.4972 18.2433 32.0003Z"
        fill="#00AFFF"
      />
      <path
        d="M31.9577 32.0003V22.5714C31.9577 22.0743 32.3607 21.6714 32.8577 21.6714C33.3548 21.6714 33.7577 22.0743 33.7577 22.5714V32.0003C33.7575 32.4972 33.3547 32.9003 32.8577 32.9003C32.3608 32.9003 31.9579 32.4972 31.9577 32.0003Z"
        fill="#00AFFF"
      />
      <path
        d="M21.6719 32.0003V22.5714C21.6719 22.0743 22.0748 21.6714 22.5719 21.6714C23.0689 21.6714 23.4719 22.0743 23.4719 22.5714V32.0003C23.4717 32.4972 23.0688 32.9003 22.5719 32.9003C22.0749 32.9003 21.6721 32.4972 21.6719 32.0003Z"
        fill="#00AFFF"
      />
      <path
        d="M25.1005 32.0003V22.5714C25.1005 22.0743 25.5034 21.6714 26.0005 21.6714C26.4975 21.6714 26.9005 22.0743 26.9005 22.5714V32.0003C26.9003 32.4972 26.4974 32.9003 26.0005 32.9003C25.5035 32.9003 25.1007 32.4972 25.1005 32.0003Z"
        fill="#00AFFF"
      />
      <path
        d="M28.5291 32.0003V22.5714C28.5291 22.0743 28.932 21.6714 29.4291 21.6714C29.9262 21.6714 30.3291 22.0743 30.3291 22.5714V32.0003C30.3289 32.4972 29.926 32.9003 29.4291 32.9003C28.9322 32.9003 28.5293 32.4972 28.5291 32.0003Z"
        fill="#00AFFF"
      />
      <path
        d="M34.5285 20.1591L25.9996 16.6845L17.4719 20.1603V21.3709C17.4719 21.5365 17.6062 21.6709 17.7719 21.6709H34.2285C34.3942 21.6709 34.5285 21.5365 34.5285 21.3709V20.1591ZM36.3285 21.3709C36.3285 22.5307 35.3883 23.4709 34.2285 23.4709H17.7719C16.6121 23.4709 15.6719 22.5307 15.6719 21.3709V19.5556C15.6719 19.1898 15.8934 18.8606 16.232 18.7224L25.6609 14.881L25.8285 14.8306C25.9989 14.7975 26.1764 14.8147 26.3395 14.881L35.7684 18.7224C36.1072 18.8605 36.3285 19.1897 36.3285 19.5556V21.3709Z"
        fill="#00AFFF"
      />
      <path
        d="M34.5285 34.8352L33.8266 33.7571H18.175L17.4719 34.8376V35.086C17.4721 35.2515 17.6063 35.386 17.7719 35.386H34.2285C34.3941 35.386 34.5283 35.2515 34.5285 35.086V34.8352ZM36.3285 35.086C36.3283 36.2456 35.3882 37.186 34.2285 37.186H17.7719C16.6122 37.186 15.6721 36.2456 15.6719 35.086V34.5716C15.6719 34.3974 15.7223 34.2265 15.8172 34.0805L16.9316 32.3661L16.9996 32.2758C17.1693 32.0753 17.4198 31.9571 17.6863 31.9571H34.3152L34.4277 31.9641C34.6882 31.9971 34.9234 32.1429 35.0688 32.3661L36.1832 34.0805C36.2781 34.2265 36.3285 34.3974 36.3285 34.5716V35.086Z"
        fill="#00AFFF"
      />
    </svg>
  );
}
